import i18n from '@/lib/i18n';

import Unit from '@/models/Unit';

type FormatUnitNamePrefixParam = {
  unitOrder: number;
};

export const formatUnitNamePrefix = ({
  unitOrder,
}: FormatUnitNamePrefixParam) =>
  i18n.t('common.unitWithOrder', { order: unitOrder });

export const formatUnitName = ({ order, name }: Pick<Unit, 'order' | 'name'>) =>
  `${formatUnitNamePrefix({ unitOrder: order })} — ${name}`;
